import script from "./login-index.vue?vue&type=script&setup=true&lang=js"
export * from "./login-index.vue?vue&type=script&setup=true&lang=js"

import "./login-index.vue?vue&type=style&index=0&id=6becb9a8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6becb9a8"]])

export default __exports__